const settings = {
  companyName: 'Getro',
  membersPerPage: 20,
  talentGroupDefaultColor: '#a6b1bf',
};

export default settings;
